<template>
  <div>
    <div class="py-1 d-flex align-items-center w-100">
      <h2 class="content-header-title float-left pr-1 mb-0">
        {{ pageTitle }}
      </h2>
      <div class="breadcrumb-wrapper no-print">
        <b-breadcrumb>
          <b-breadcrumb-item to="/">
            <feather-icon icon="HomeIcon" size="16" class="align-text-top" />
          </b-breadcrumb-item>
          <b-breadcrumb-item
            v-for="item in breadcrumbs"
            :key="item.text"
            :active="item.active"
            :to="item.to"
          >
            <feather-icon icon="ChevronLeftIcon" class="text-dark mx-1" />
            <span>
              {{ item.text }}
            </span>
          </b-breadcrumb-item>
        </b-breadcrumb>
      </div>
      <b-button
        title="طباعة"
        variant="info"
        class="ml-auto btn-icon no-print"
        @click="onPrint"
        ><feather-icon size="16" icon="PrinterIcon" />
      </b-button>
    </div>
    <b-card id="to-print">
      <div style="position: relative">
        <loading-overlay :loading="loading" />
        <!-- <drag /> -->
        <b-row>
          <b-col
            class="p-1"
            :cols="typeof val === 'string' && val.length > 100 ? 6 : 3"
            v-for="(val, key) in dataObj"
            :key="key"
          >
            <h4 class="text-primary">{{ $t(key) }}</h4>
            <template v-if="htmlFields.indexOf(key) !== -1">
              <div v-html="val"></div>
            </template>
            <template v-else>
              <span>{{ val | formatView }}</span>
            </template>
          </b-col>
        </b-row>
      </div>
    </b-card>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import viewsMeta from "./views-meta";
import {
  BButton,
  BRow,
  BContainer,
  BCol,
  BBreadcrumb,
  BBreadcrumbItem,
  BCard,
  BCardTitle,
  BFormRow,
  VBTooltip,
} from "bootstrap-vue";
import FeatherIcon from "@/@core/components/feather-icon/FeatherIcon.vue";
import LoadingOverlay from "@/components/LoadingOverlay.vue";
export default {
  components: {
    BButton,
    BRow,
    BContainer,
    BCol,
    BBreadcrumb,
    BBreadcrumbItem,
    BCard,
    BCardTitle,
    BFormRow,
    FeatherIcon,
    LoadingOverlay,
  },
  directives: {
    "b-tooltip": VBTooltip,
  },
  props: {
    id: Number | String,
    slug: String,
  },
  data() {
    return {
      htmlFields: [
        "skill_ar",
        "skill_en",
        "certificate_ar",
        "certificate_en",
        "experience_ar",
        "experience_en",
      ],
    };
  },
  filters: {
    formatView(val) {
      return val === true
        ? "نعم"
        : val === false
        ? "لا"
        : val.name_ar
        ? val.name_ar
        : val.name
        ? val.name
        : val;
    },
  },
  computed: {
    ...mapGetters("Ministry/NgosData", ["dataObj", "labels", "loading"]),
    breadcrumbs() {
      return viewsMeta[this.slug].breadcrumbs;
    },
    pageTitle() {
      return viewsMeta[this.slug].title;
    },
  },
  methods: {
    ...mapActions("Ministry/NgosData", ["fetchRecordData"]),
    onPrint() {
      // printJS({
      //   printable: "to-print",
      //   type: "html",
      //   targetStyles: ["*"],
      // });
      print();
    },
  },
  created() {
    this.fetchRecordData({ id: this.id, slug: this.slug });
  },
};
</script>

<style lang="scss">
@media print {
  .no-print {
    display: none !important;
  }
}
</style>
